<template>
  <div class="sign-in-container">
    <b-card class="sign-in-card col-sm-8 col-md-8 col-lg-6">
      <b-row>
        <b-col class="col-1">
          <b-img :src="require('./../assets/stuff_to_do_logo.png')" class="logo"></b-img>
        </b-col>
        <b-col>
          <span class="app-name-text">Stuff To-Do</span>
        </b-col>
      </b-row>

      <h1 class="card-title">Sign in</h1>

      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Email</label>
            <b-form-input
                type="email"
                :state="informationValidation.isEmailProvided && informationValidation.isEmailValid"
                v-model="email"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isEmailProvided">
              This field must not be empty.
            </b-form-invalid-feedback>

            <b-form-invalid-feedback v-if="!informationValidation.isEmailValid">
              Please provide a valid email address.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">Password</label>
            <b-form-input
                type="password"
                :state="informationValidation.isPasswordValid"
                v-model="password"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isPasswordValid">
              The password must be at least 6 characters long.
            </b-form-invalid-feedback>

          </b-col>
        </b-row>
      </div>

      <b-button block class="sign-in-button" @click="navigateToHomePage">Sign in</b-button>

      <b-row>
        <b-col>
          <p class="sign-up-option-text">Don't have an account? <span class="sign-up-text" @click="navigateToSignUpPage">Sign up</span></p>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
        id="loading-modal"
        size="sm"
        centered
        no-close-on-backdrop
        hide-header
        hide-footer>
      <img
          width="265px"
          class="center-image"
          src="../assets/animated_loading.gif"
          alt="loading animation">
    </b-modal>
  </div>
</template>

<script>
  import {required, email, minLength} from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
        email: '',
        password: '',
        informationValidation: {
          isEmailProvided: null,
          isEmailValid: null,
          isPasswordValid: null
        }
      }
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLen: minLength(6)
      },
    },
    methods: {
      navigateToHomePage() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.email.required) {
          this.informationValidation.isEmailProvided = false
          isValid = false
        } else {
          this.informationValidation.isEmailProvided = true
        }

        if (!this.$v.email.email) {
          this.informationValidation.isEmailValid = false
          isValid = false
        } else {
          this.informationValidation.isEmailValid = true
        }

        if (!this.$v.password.required || !this.$v.password.minLen) {
          this.informationValidation.isPasswordValid = false
          isValid = false
        } else {
          this.informationValidation.isPasswordValid = true
        }

        if (isValid) {
          const userData = {
            email: this.email,
            password: this.password
          }
          this.$store.dispatch('signIn', userData)
        }
      },
      navigateToSignUpPage() {
        this.$router.push({name: 'Sign Up'})
      }
    }
  }
</script>

<style scoped>
  .sign-in-container {
    width: 80%;
    margin: 0 auto;
  }

  .logo {
    width: 2em;
  }

  .sign-in-card {
    margin: 2em auto;
  }

  .app-name-text {
    font-size: 1.2em;
    font-weight: bold;
    color: #212441;
  }

  .center-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .card-title {
    font-size: 2em;
  }

  .input-container {
    margin: 1em 0;
  }

  .input-title {
    font-weight: bold;
  }

  .sign-in-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .sign-in-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }

  .sign-up-option-text {
    text-align: center;
    margin-top: 1em;
    margin-bottom: 0;
  }

  .sign-up-text {
    color: #212441;
    font-weight: bold;
  }

  .sign-up-text:hover {
    color: #212441;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }

  .warning-text {
    margin-bottom: 0;
    color: red;
  }

</style>
